// Utility to ensure favicon is always properly set
export const ensureFavicon = () => {
  try {
    // Check if favicon already exists and is working
    const existingFavicon = document.querySelector('link[rel="icon"][href="/favicon.ico"]');
    if (existingFavicon) {
      console.log('✅ Favicon already exists, refreshing...');
      // Force refresh by adding timestamp
      existingFavicon.setAttribute('href', '/favicon.ico?v=' + Date.now());
      return;
    }

    // Remove any existing favicon links to avoid conflicts
    const existingLinks = document.querySelectorAll('link[rel*="icon"], link[rel="shortcut icon"]');
    existingLinks.forEach(link => {
      console.log('🗑️ Removing existing favicon link:', link.getAttribute('href'));
      link.remove();
    });

    // Add fresh favicon links with cache busting
    const timestamp = Date.now();
    const faviconLinks = [
      { rel: 'icon', href: `/favicon.ico?v=${timestamp}`, type: 'image/x-icon' },
      { rel: 'shortcut icon', href: `/favicon.ico?v=${timestamp}`, type: 'image/x-icon' },
      { rel: 'icon', href: `/favicon-32x32.png?v=${timestamp}`, sizes: '32x32', type: 'image/png' },
      { rel: 'icon', href: `/favicon-16x16.png?v=${timestamp}`, sizes: '16x16', type: 'image/png' },
      { rel: 'apple-touch-icon', href: `/apple-touch-icon.png?v=${timestamp}`, sizes: '180x180' }
    ];

    faviconLinks.forEach(linkData => {
      const link = document.createElement('link');
      Object.entries(linkData).forEach(([key, value]) => {
        link.setAttribute(key, value);
      });
      document.head.appendChild(link);
      console.log('✅ Added favicon link:', linkData.href);
    });
    
    console.log('🎯 Favicon setup completed with cache busting');
  } catch (error) {
    console.error('❌ Error setting favicon:', error);
  }
};

// Force refresh favicon (useful for debugging)
export const refreshFavicon = () => {
  const link = document.querySelector('link[rel*="icon"]') as HTMLLinkElement;
  if (link) {
    const href = link.href;
    link.href = href + '?v=' + Date.now();
  }
};
